function extractTextFromHTML(htmlString)
{
    // checks if we are in the browser
    // in order to use the DOMParser
    if (typeof window === 'undefined')
    {
        return '';
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body.textContent.trim() || '';
}

const articleTitleTransformer = (queried) =>
{
    // Check if the queried data contains the post and author information
    const authorNode = queried?.post?.author?.node || false;
    if (!authorNode)
    {
        return null;
    }
    // Get the author profile information
    const authorProfile = authorNode?.cdmfields?.author || false;
    // Check if the author has a local avatar
    const authorAvatar =
        authorNode?.localAvatar?.childImageSharp?.gatsbyImageData || false;
    // create the author object with required fields for ArticlePostPage
    const author = {
        id: authorNode?.databaseId ? String(authorNode.databaseId) : authorNode?.id || '',
        label: authorProfile?.displayName || authorNode?.name || '',
        href: authorNode?.uri || '',
        image: authorAvatar,
        name: authorProfile?.displayName,
        role: extractTextFromHTML(authorProfile?.expertise),
        social: authorProfile?.socialLinks,
        description: authorNode?.description,
        profile: authorNode?.uri,
    };
    return author;
};
export default articleTitleTransformer;
